// extracted by mini-css-extract-plugin
export default {"container":"about_container__6SbTm","h1":"about_h1__h9MKc","about":"about_about__YZE5H","education":"about_education__UTt2N"};